if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.classList.add('product-form-loaded');
        
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('response', response)
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

        //       if(response.status == 422) {

        // $.ajax({
        //   type: 'GET',
        //   url: `${routes.cart_url}?view=fullcart`,
        //   success: function(htm) {
        //     $('cart-drawer').removeClass('is-empty');
        //     $('cart-drawer').html(htm);

        //     $('.modal').removeClass('is-visible');
        //     // if (that.hasClass('propage')) {
        //       $('cart-drawer').addClass('animate active')
        //     // }  
        //   },
        //   error: function(err) {
        //     console.log(err);   
        //     that.find('span').show();
        //     that.find('.loading-overlay__spinner').addClass('hidden');               
        //   }
        // }); 
                
        //         console.log('renderingn')
                
        //       }
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;

              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            $('#cart-icon-bubble').addClass('item-count-active');
            const quickAddModal = this.closest('quick-add-modal');

            var addup = $('div#sel-custom-options .custom-options .variant__input-shaft-options option:selected').attr('vupgradeid');
            var addup_grip_option = $('div#sel-custom-options .custom-options .variant__input-gripoptions option:selected').attr('vupgradeid');
            var addup_length_upgrade = $('div#sel-custom-options .custom-options .variant__input-custom_length_option option:selected').attr('vupgradeid');
            var addup_irons_upgrade = $('div#sel-custom-options .custom-options .variant__input-custom_irons_included option:selected').attr('vupgradeid');
            var addup_clubs_upgrade = $('div#sel-custom-options .custom-options .variant__input-custom_additional_clubs option:selected').attr('vupgradeid');

            let formDataCustomSelection = {
              'items': []
            };
            var resultqt = parseInt($('.buy-button-wrapper input.quantity__input').val());
  //           UPGRADED ITEMS ELEVATEIN
            if (addup || addup_grip_option || addup_length_upgrade || addup_irons_upgrade || addup_clubs_upgrade) {
              var product = response;
              var idAdd = addup;
              if (addup) {
                idAdd = addup;
                formDataCustomSelection['items'].push({
                  'id': addup,
                  'quantity': resultqt,
                  'properties': {
                    'parent': product.id
                  }
                });
              }
              if (addup_grip_option) {
                idAdd = addup_grip_option;
                formDataCustomSelection['items'].push({
                  'id': addup_grip_option,
                  'quantity': resultqt,
                  'properties': {
                    'parent': product.id
                  }
                });
              }
              if (addup_length_upgrade) {
                idAdd = addup_length_upgrade;
                formDataCustomSelection['items'].push({
                  'id': addup_length_upgrade,
                  'quantity': resultqt,
                  'properties': {
                    'parent': product.id
                  }
                });
              } 
              if (addup_irons_upgrade) {
                idAdd = addup_irons_upgrade;
                formDataCustomSelection['items'].push({
                  'id': addup_irons_upgrade,
                  'quantity': resultqt,
                  'properties': {
                    'parent': product.id
                  }
                });
              } 
              if (addup_clubs_upgrade) {
                idAdd = addup_clubs_upgrade;
                formDataCustomSelection['items'].push({
                  'id': addup_clubs_upgrade,
                  'quantity': resultqt,
                  'properties': {
                    'parent': product.id
                  }
                });
              }            
              
              fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formDataCustomSelection)
              })
              .then(responseIn => {                
                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: idAdd,
                    cartData: response,
                  });
                this.error = false;
                // this.cart.renderContents(response);
              })
              .catch((error) => {
                console.error('Error:', error);
              });
  //             END oF UPGRADED ITEMS
            } else {              
              if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              this.error = false;
            }
            
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              console.log("ininini")
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            $('.loading__spinner').addClass('hidden');
          });
          
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
